import QueryString from 'utils/query_string';

export default class NestedSelects {
  static populateChildFromQueryString($parentSelect, $childSelect) {
    this.loaded = [];
    const data = QueryString.getQueryStringData(
      $childSelect.parents('form').data('current-params')
    );
    const parentConfig = $parentSelect.qselect('getConfig');
    const childConfig = $childSelect.qselect('getConfig');
    const parentName = parentConfig.name + (parentConfig.multiple ? '[]' : '');
    const childName = childConfig.name + (childConfig.multiple ? '[]' : '');
    const parentValues = data[parentName];
    const childValues = data[childName];

    if (this.loaded.indexOf(childName) > -1) {
      return;
    }

    if (
      parentValues &&
      parentValues.length &&
      childValues &&
      childValues.length
    ) {
      $childSelect.qselect('setValue', childValues);
      this.loaded.push(childName);
    }
  }

  static onChange($parentSelect, $childSelect, urlParamName, values) {
    if (values && values.length) {
      let childCurrentValue = $childSelect.get(0).dataset.value;
      childCurrentValue =
        childCurrentValue instanceof Array
          ? childCurrentValue.filter(x => !!x)
          : childCurrentValue;

      const url = $childSelect.data('ajax-url');
      const urlParts = url.split('?');
      const baseUrl = urlParts[0];
      const params =
        urlParts.length > 1
          ? QueryString.getQueryStringData(url.split('?')[1])
          : {};
      values = values instanceof Array ? values : [values];
      params[urlParamName] = values.join(',');

      $childSelect
        .qselect('enable')
        .qselect('setConfig', { ajaxUrl: `${baseUrl}?${$.param(params)}` })
        .qselect('fetch', null, childCurrentValue);
    } else {
      $childSelect.qselect('reset', true).qselect('disable');
    }
  }

  static init($parentSelect, $childSelect, urlParamName) {
    $parentSelect
      .qselect('on', 'fetch', () =>
        this.populateChildFromQueryString($parentSelect, $childSelect)
      )
      .qselect('on', 'change', values =>
        NestedSelects.onChange(
          $parentSelect,
          $childSelect,
          urlParamName,
          values
        )
      );
  }
}
